import React, { useState } from "react";

const ReturnRequest = () => {
  const [orderInput, setOrderInput] = useState("");
  const [reason, setReason] = useState("");
  const [details, setDetails] = useState("");
  const [submitted, setSubmitted] = useState(null);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setSubmitted(null);

    const pattern = /^#[0-9]{5}$/;

    if (!pattern.test(orderInput.trim())) {
      setError("❗ Please enter a valid order ID (example: #12345)");
      return;
    }

    if (!reason) {
      setError("❗ Please select a return reason.");
      return;
    }

    setTimeout(() => {
      setSubmitted({
        id: orderInput.trim(),
        date: new Date().toLocaleDateString(),
        time: new Date().toLocaleTimeString(),
        reason,
        details: details || "No additional details provided.",
        status: "Return request successfully submitted 🎉",
      });
    }, 600);
  };

  return (
    <section style={{ background: "#f6f7fb", padding: "80px 0" }}>
      <div className="container" style={{ maxWidth: "750px" }}>
        {/* HEADER */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <h2 style={{ fontWeight: 700, fontSize: "32px" }}>
            Request a Return
          </h2>
          <p style={{ color: "#777", marginTop: "6px" }}>
            Tell us what happened — we’re here to help.
          </p>
        </div>

        {/* MAIN FORM CARD */}
        <div
          style={{
            background: "#fff",
            padding: "40px",
            borderRadius: "20px",
            boxShadow: "0px 12px 30px rgba(0,0,0,0.06)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "50%",
                background: "#111",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "20px",
              }}
            >
              ↺
            </div>
            <h4 style={{ margin: 0, fontWeight: 600 }}>Return Request Form</h4>
          </div>

          <form onSubmit={handleSubmit}>
            {/* ORDER INPUT */}
            <label className="form-label">Order ID *</label>
            <input
              type="text"
              value={orderInput}
              onChange={(e) => setOrderInput(e.target.value)}
              placeholder="Example: #12345"
              style={inputField}
            />

            {/* REASON */}
            <label className="form-label">Reason for Return *</label>
            <select
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              style={inputField}
            >
              <option value="">Select a reason</option>
              <option value="Damaged Product">Received Damaged Product</option>
              <option value="Wrong Item Received">Wrong Item Received</option>
              <option value="Not as Described">Product Not as Described</option>
              <option value="Missing Parts">Missing Parts/Accessories</option>
              <option value="Defective">Defective or Malfunctioning</option>
              <option value="Other">Other</option>
            </select>

            {/* DETAILS */}
            <label className="form-label">Additional Details (Optional)</label>
            <textarea
              rows="4"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              placeholder="Tell us what went wrong..."
              style={{ ...inputField, height: "120px", resize: "none" }}
            ></textarea>

            {/* SUBMIT BUTTON */}
            <button type="submit" style={submitBtn}>
              Submit Return Request
            </button>
          </form>

          {/* ERROR DISPLAY */}
          {error && (
            <div
              style={{
                marginTop: "18px",
                color: "#d40000",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              {error}
            </div>
          )}

          {/* HINT */}
          <p style={{ marginTop: "20px", fontSize: "14px", color: "#666" }}>
            Need help finding your order ID? Check your order confirmation
            email.
          </p>

          {/* SUCCESS BOX */}
          {submitted && (
            <div
              style={{
                marginTop: "35px",
                background: "#f9fff8",
                padding: "25px",
                borderRadius: "12px",
                border: "1px solid #d3f7d7",
              }}
            >
              <h5
                style={{
                  fontWeight: 600,
                  marginBottom: "12px",
                  color: "#1a8a2e",
                }}
              >
                {submitted.status}
              </h5>

              <p>
                <strong>Order ID:</strong> {submitted.id}
              </p>
              <p>
                <strong>Reason:</strong> {submitted.reason}
              </p>
              <p>
                <strong>Details:</strong> {submitted.details}
              </p>
              <p style={{ color: "#555", marginTop: "6px" }}>
                Submitted on {submitted.date} at {submitted.time}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

/* ------- STYLES -------- */

const inputField = {
  width: "100%",
  padding: "14px 16px",
  borderRadius: "12px",
  border: "1px solid #ddd",
  marginBottom: "18px",
  fontSize: "15px",
  outline: "none",
};

const submitBtn = {
  width: "100%",
  padding: "16px",
  background: "#111",
  color: "#fff",
  borderRadius: "12px",
  border: "none",
  cursor: "pointer",
  fontWeight: 600,
  fontSize: "16px",
  transition: ".3s",
};

export default ReturnRequest;
